<template lang="pug">
  .address-row(:class="classes")
      .address-row__delete-icon(v-if="newValue && challengeMode && !challengeLine" @click="cancelChallenge")
        font-awesome-icon(icon="trash-alt" regular size="sm")
      .address-row__updated-value(v-if="newValue && challengeMode"
        @click="openChallenge(true)"
        :class="updateHoverClass"
      )
        p {{newValue}}
      .address-row__current-value(
        @click="openChallenge()"
        :class="hoverClass")
        .address-row__icon(v-if="challengeMode && !challengeLine")
          lei-popover(:text="tooltip" :trigger="'hover'" :placement="'left'" :width="150")
            font-awesome-icon(icon="pen")
        lei-popover(:text="tooltip" :trigger="'hover'" :placement="'right'" :width="150")
          p(:class="{'n-a':isEmpty(address) && !disabled}") {{parsedAddress || 'not available'}}
      challenge-row(
        v-if="challengeMode && challengeLine"
        :challenge="inLineChallenge(field)"
        @close="closeChallenge"
      )
</template>
<script>
import { mapState, mapMutations, mapGetters, } from 'vuex'
import {
  RM_FIELD,
} from '@/store/modules/record/modules/challenge/mutations-types'
import Challenge from '@/mixins/challenge'
import { getFieldByPath, } from '@/utils/challenge'
import LeiPopover from '@/components/lei-components/LeiPopover'
import ChallengeRow from '../table-components/ChallengeRow'

export default {
  components: {
    LeiPopover,
    ChallengeRow,
  },
  mixins: [ Challenge, ],
  props: {
    tooltip: {
      type: String,
      required: true,
    },
    address: {
      type: [ String, Object, ],
      default: null,
    },
    jsonPath: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      challengeLine: false,
      field: {},
    }
  },
  computed: {
    classes () {
      return {
        'address-row__challenge': this.challengeMode && !this.disabled,
        'address-row__disabled': this.disabled,
      }
    },
    hoverClass () {
      return {
        'address-row__hover': !this.challengeLine && !this.newValue,
      }
    },
    updateHoverClass () {
      return {
        'address-row__hover-updated': !this.challengeLine && this.newValue,
      }
    },
    parsedAddress () {
      const { code, name, } = this.address || {}
      if (code && name) return `${code} | ${name}`
      else if (code) return code
      return this.address
    },
    newValue () {
      const newValue = this.getSavedFieldByPath(this.jsonPath)
      const { code, name, } = newValue || {}
      if (code && name) return `${code} | ${name}`
      else if (code) return code
      return newValue
    },
    disabled () {
      return this.challengeMode && this.addressesSectionIsBlocked
    },
    ...mapState('record', [ 'showEmptyFields', ]),
    ...mapGetters('record', [ 'addressesSectionIsBlocked', ]),
    ...mapGetters('record/challenge', [ 'getAllSavedFieldsByPath', 'getSavedFieldByPath', ]),
  },
  created () {
    this.composeField()
  },
  methods: {
    composeField () {
      const field = getFieldByPath(this.jsonPath)
      this.field = field ? {
        ...field,
        jsonPath: this.jsonPath,
        value: this.address,
      } : {
        jsonPath: this.jsonPath,
        value: this.address,
      }
    },
    isEmpty: (value) => !value || value === '',
    inLineChallenge (item) {
      let oldValue
      if (this.tooltip === 'Region') oldValue = { code: item.value, }
      else oldValue = item.value
      return {
        ...item,
        title: '',
        oldValue,
      }
    },
    closeChallenge () {
      this.challengeLine = false
    },
    openChallenge (updated) {
      if (this.disabled) return
      if (this.newValue && !updated) return
      this.challengeLine = true
    },
    cancelChallenge () {
      this.removeField(this.jsonPath)
    },
    ...mapMutations('record/challenge', {
      removeField: RM_FIELD,
    }),
  },
}
</script>
<style lang="stylus">
@import "../../../assets/styles/variables.styl"

.address-row
  display flex
  width 100%
  min-height 45px
  line-height 1.5
  position relative
  flex-direction column
  padding-bottom 2px
  text-align left

  &__icon
    display none
    background $white-color
    border-radius 50%
    border 1px solid $primary-hover
    box-shadow 1px 4px 6px -2px rgba(0,0,0,0.69)
    height 35px
    width 35px
    justify-content center
    align-content center
    position absolute
    top 50%
    right -15px
    transform: translateY(-50%);

  &__delete-icon
    position absolute
    height 24px
    width 24px
    justify-content center
    display flex
    z-index 2
    color $primary-color
    background $primary-color-light-2
    border-radius 50%
    border 1px solid $primary-color
    align-items center
    top -11px
    right -11px
    &:hover
      background $primary-color
      color $primary-color-light-2

  &__current-value
    width 100%
    height 100%
    padding 12px 17px
    background-color $default-color-light-2
    border 3px solid $default-color-light-2
    position relative
    font-weight 500
    .n-a
      color $default-color-middle

  &__updated-value
    width 100%
    height 100%
    z-index 1
    position relative
    background-color $warning-color-light-2
    border-right 5px solid $warning-color
    padding 15px 20px


  &__disabled
    .address-row__current-value
      cursor not-allowed
      background-color $disabled-bg
      border-color $disabled-bg
      color $disabled-color

  &__challenge
    .address-row__hover:hover
      cursor pointer
      background-color $primary-hover
      border 3px solid $primary-color
      .address-row__icon
        display flex


    .address-row__hover-updated:hover
      cursor pointer
      background-color $warning-color-light-1


@media (max-width: $tablet)
  .address-row
    border-bottom none
    font-size 90%
    border-bottom 1px solid $default-color-light-1
    flex-direction column
    justify-content flex-start
    align-items flex-start
    background-color transparent
    width 100%
    min-width auto
    margin 0
    text-align left
    padding 5px 0 5px 10px

    &__current-value
      background-color transparent
      border none
      padding 5px 0 5px 10px

    &__updated-value
      padding 5px 0 5px 10px
      margin-bottom 5px

    &__delete-icon
      top -10px
      right -10px

    &__icon
      height 30px
      width 30px

    &__challenge
      .address-row__hover:hover
        background-color transparent
        border none


</style>



// WEBPACK FOOTER //
// src/components/record-details/address/AddressRow.vue